import { Route } from "react-router";
import { Navigate, Routes } from "react-router-dom";
import AppRoutesUtil from "../../app/AppRoutesUtil";
import Login from "../../auth/Login";


const MainSwitch = () => {
    document.title = "Zelda Randomizer";

    // console.log(AppRoutesUtil.generatedRoutes)
    return (
        <Routes>
            <Route path="/login" element={<Login />} />

            {AppRoutesUtil.generatedRoutes.map((route: JSX.Element) => route)}
            {/* <Route path="/ootr/tracker" element={<Main />} />
            <Route path="/tpr/drehen/s1" element={<DrehenTournamentS1 />} /> */}
            <Route path="/" element={<Navigate to="/ootr/tracker/items" />} />
        </Routes>
    )
}

export default MainSwitch